export function getCurrentPageNumber(listWrapperRootElement: HTMLElement): number {
    const currentPageElement = findHtmlElementOfCurrentPageIndicator(listWrapperRootElement);
    if (!currentPageElement) {
        return 1;
    }

    const currentPageNumber = parseInt(currentPageElement.textContent ?? '');
    if (isNaN(currentPageNumber)) {
        return 1;
    }
    return currentPageNumber;
}

function findHtmlElementOfCurrentPageIndicator(listWrapperRootElement: HTMLElement) {
    return listWrapperRootElement.querySelector<HTMLInputElement>('.js_cr_list-wrapper__pagination-current-page');
}
